import type { RootState } from '~/store/store.ts';

export const selectFormPersonsInfoRemoteBankingContacts = (state: RootState) =>
  state.remoteBankingContacts?.formPersonsInfo || {};

export const selectFormPersonsRemoteBankingContacts = (state: RootState) =>
  state.remoteBankingContacts?.formPersons || {};

export const selectIsLoadingRemoteBankingContacts = (state: RootState) =>
  state.remoteBankingContacts?.loading;

export const selectErrorRemoteBankingContacts = (state: RootState) =>
  state.remoteBankingContacts?.error;
